<template>
  <div class="container-fluid">
    <el-container>
      <el-header height="15%">
        <el-alert
          v-if="status === 200"
          :title="message"
          type="success"
          effect="dark"
        >
        </el-alert>
        <div class="row mt-4">
          <h4>Комметарии к статьям</h4>
        </div>
      </el-header>
      <el-main height="80%">
        <el-form aria-label="Поиск">
          <el-row>
            <el-col :span="8">
              <el-form-item label="Поиск по статье">
                <el-select
                  v-model="query.article"
                  no-data-text="Нет данных"
                  placeholder="Нет данных"
                  clearable
                  filterable
                  @change="setQueryReset"
                >
                  <el-option
                    v-for="item in articles"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Сортировка">
                <el-select
                  v-model="query.sort"
                  :width="300"
                  no-data-text="Нет данных"
                  placeholder="Нет данных"
                  @change="setQuery"
                >
                  <el-option
                    value="status.desc"
                    label="Сначала непроверенные"
                  ></el-option>
                  <el-option
                    value="status.asc"
                    label="Сначала проверенные"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="comments" empty-text="Нет данных" style="width: 100%">
          <el-table-column prop="id" label="Id" width="150"> </el-table-column>
          <el-table-column prop="text" label="Текст комментария">
          </el-table-column>
          <el-table-column prop="user.name" label="Пользователь">
            <template slot-scope="scope">
              {{ comments[scope.$index].user.full_name }}
            </template>
          </el-table-column>
          <el-table-column prop="article" label="Статья">
            <template slot-scope="scope">
              {{ comments[scope.$index].article.title }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="Статус">
            <template slot-scope="scope">
              {{
                comments[scope.$index].status === "checked"
                  ? "Проверен"
                  : "Не проверен"
              }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="Действия" width="300">
            <template slot-scope="scope">
              <el-button
                v-if="comments[scope.$index].status === 'no_checked'"
                class="el-button-confirm"
                type="success"
                size="mini"
                @click="(e) => Confirm(comments[scope.$index].id, e)"
                >Подтвердить
              </el-button>
              <el-popconfirm
                :title="'Удалить этот комментарий?'"
                :hide-icon="true"
                :confirmButtonText="'Да'"
                :cancelButtonText="'Нет'"
                @onConfirm="(e) => deleteComment(comments[scope.$index].id, e)"
              >
                <template #reference>
                  <el-button
                    size="mini"
                    type="danger"
                    plain
                    class="el-table__row--remove-btn"
                  >
                    Удалить
                  </el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="5%">
        <el-pagination
          v-show="paginator"
          background
          layout="prev, pager, next"
          :total="paginator ? paginator.total : 0"
          :current-page.sync="current"
          @current-change="getPage(current)"
          :hide-on-single-page="false"
          :page-size="paginator ? paginator.per_page : 0"
          :page-count="paginator ? paginator.last_page : 0"
        >
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from "../store/mutation-types.js";

export default {
  name: "Comments",
  data: function () {
    return {
      paginator: [],
      comments: [],
      current: 0,
      status: 0,
      message: "",
      noCheckedQuanity: "",
      query: {
        article: "",
        sort: "status.desc",
        page: 1,
      },
      articles: [],
    };
  },
  mounted() {
    this.$store.commit(SETPRELOADER_STATE, true);
    this.initParams(this.$route.query);
    this.fetchData()
      .then((data) => {
        this.$store.commit(SETPRELOADER_STATE, false);

        const [articles] = data;

        this.articles = articles.data;
      })
      .catch((e) => {
        this.$store.commit(SETPRELOADER_STATE, false);

        if (e.status === 401) {
          this.$router.push("/login");
        }
      });
    this.getComments(this.getQuery(this.getQueryObj().obj));
  },
   watch:{
    '$route.query'(v){   
            const query = this.getQuery(v)   
            if (query){              
                this.getComments(query)
            }
        }
    },
  methods: {
    fetchData() {
      return Promise.all([this.getArticles()]);
    },
    async getArticles() {
      const response = await axios.get("/comment/articles");

      return response;
    },
    async getComments(query) {
      const response = await axios.get("/comment" + query).then((response) => {
          this.paginator = response.data.meta;
          this.comments = response.data.data;
          this.current = response.data.meta.current_page;
      });
  
      return response;
    },
    findByArticle(idArticle) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      axios
        .get(`comment/?article_id=${idArticle}`)
        .then(() => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);


          this.sortComments(this.query.sort, this.comments);
        })
        .catch((e) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          if (e.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    sortComments(value, comments) {
      this.comments = comments || this.comments;

      this.query.sort = value;

      const sortItems = this.$store.getters.sortItems;

      const current = sortItems.find((el) =>
        el.names.includes(this.query.sort)
      );

      if (current) {
        const key = this.query.sort.split(".")[0];
        current.sort(this.comments, key);
      }
    },
    getTarget(e) {
      const t = e.target;

      return t.classList.contains("el-button") ? t : t.parentNode;
    },
    Confirm(id, e) {
      const btn = this.getTarget(e);

      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      btn.style.pointerEvents = "none";

      axios
        .post(`comment/${id}/confirm`)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          this.status = response.status;
          this.message = "Комментарий опубликован";

          btn.style.pointerEvents = "all";

          this.comments = [...this.comments.filter((el) => el.id !== id)];

          this.sortComments(this.query.sort, this.comments);
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          btn.style.pointerEvents = "all";
          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    deleteComment(id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      axios
        .delete(`comment/${id}`)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          this.status = response.status;
          this.message = "Комментарий удален";

          this.comments = [...this.comments.filter((el) => el.id !== id)];

          this.sortComments(this.query.sort, this.comments);
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    getPage: function (pageNum) {
      if (pageNum) {
        this.query.page= pageNum
        this.setQuery()
      }
    },
    getSortObj(){
      const sortArr = this.query.sort.split('.')
      return {
        by: sortArr[0],
        order: sortArr[1]
      }
    },
    setQueryReset(){
        this.query.page = 1
        this.setQuery()
    },
    getQueryObj(){
        const result = {};
        let isChange = false;
        
        if (this.query.sort) {
            isChange = true;
            const sort = this.getSortObj()
            result['sort']= {
            by: sort.by,
            order: sort.order
        } 
        }
        if (this.query.article) {
            isChange = true;
            result['article']=this.query.article
        }
        if(this.query.page){
            isChange = true
            result['page']=this.query.page
        }

        return {
            isChange,
            obj: result,
        }
    },
    setQuery(){
        const result = this.getQueryObj();

        if (result.isChange) {
        const q = this.getQuery(result.obj)
            this.$router.push({
                path: 'comments' + q,
            })
        }
    }, 
    getQuery(query) {
        if (Object.keys(query).length > 0){        
        const qs = require('qs');
        return `?${qs.stringify(query)}`
        }
        return ''
    },
    initParams(query){
      if (!query){
        return
      }
      const qs = require('qs');
      const parseQuery= qs.parse(query);

      if (parseQuery.sort?.by && parseQuery.sort?.order) {
        this.query.sort = `${parseQuery.sort.by}.${parseQuery.sort.order}`
      }
      if (parseQuery.article){
        this.query.article = Number.parseInt(parseQuery.article)
      }
      if(parseQuery.page){
          this.query.page = parseQuery.page
      }
    }
  },
};
</script>

<style scoped>
.el-button-confirm {
  margin-right: 25px;
}
</style>